

import { createContext  } from 'react';
import IEnterpriseInfo  from '../interface/enterpriseInfo';
import IUserInfo  from '../interface/userInfo';
import { ICommonHeaderData }  from '../interface/base';

export enum APP_ACTION_TYPE {
    UPDATE_CONFIG = 1,  // 外界更新，比如更新登录用户

}

export interface IAppAction {
    type: APP_ACTION_TYPE;
    payload: any;
}

export interface IAppProps {
    state: ICommonHeaderData;
    // dispatch: Dispatch<IAppAction>;
}


export interface IAppContextProps {
    userInfo: IUserInfo;
    enterpriseInfo: IEnterpriseInfo;
}

export const AppContext = createContext<IAppProps>({} as IAppProps);
